import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import AboutSection from '@/pages/home/components/AboutSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import ContactSection from '@/pages/home/components/ContactSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AppSection from '@/pages/home/components/AppSection';
import MediaSection from '@/pages/home/components/MediaSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <FeaturesSection />
        <CardsSection />
        <IndexSection />
        <RankingSection />
        <CarouselSection />
        <ContactSection />
        <TopicsSection />
        <UpdatesSection />
        <FaqSection />
        <AppSection />
        <MediaSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}